import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import BasicForm from './basic-form/basic-form.vue';
import attachmentInfo from './attachment-info/attachment-info.vue';
import BasicText from './batch-text/commitment-text.vue';
import PublishProjectService from '../publish-project-service.js';
import { errorMessage } from '@/utils/message.js';
const debounce = require('lodash.debounce');
import { mapGetters } from 'vuex';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation,
    BasicForm,
    BasicText,
    attachmentInfo
  },
  data () {
    return {
      processList: ['编辑项目信息', '上传附件信息', '承诺信息', '提交申请'],
      step: 1,
      showstep: '1',
      showfile: '',
      id: '',
      oldId: '',
      isCreated: true,
      projectInfo: {},
      landTotalForm: {},
      submitStatus: 'init',
      projectType: '1',
      projectSubType: '1',
      test: null,
      assetsCode: '',
      fileinfo: '',
      batchinfo: '',
      dataid: '',
      getfilelist: [],
      fileinforaw: '',
      isFileInfo: {}
    };
  },
  computed: {
    ...mapGetters([
      'tradeType'
    ])
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    if (Number(this.tradeType) === 3) {
      this.step = 1;
    }
    // this.resultGet();
    this.id && this.selectInfoByProjectId(this.id) && this.getFile();
  },
  methods: {
    fromClear () {
      this.$nextTick(() => {
        Object.keys(this.$refs).forEach(item => {
          if (this.$refs[item] && this.$refs[item].clear) {
            this.$refs[item].clear && this.$refs[item].clear();
          }
        });
      });
    },
    // 获取项目详情
    selectInfoByProjectId (id) {
      PublishProjectService.getBatchProject(id).then(res => {
        // console.log(res);
        this.projectInfo = res.data;
      });
    },
    // 获取文件详情
    getFile () {
      PublishProjectService.getFile(this.id).then(res => {
        // console.log(res);
        this.isFileInfo = res.data;
      });
    },
    resultGet () {
      if (this.id || this.oldId) {
        PublishProjectService.getProjectInfo({
          projectId: this.id || this.oldId,
          echoCode: 'PROJECT'
        }).then(res => {
          if (!res.data) {
            return;
          }
          this.projectInfo = res.data;
          if (res.data.projectType) {
            this.projectType = res.data.projectType;
          };
          if (res.data.projectSubType) {
            this.projectSubType = res.data.projectSubType;
          };
          if (this.oldId && !this.id) {
            this.isCreated = true;
          } else {
            this.isCreated = false;
          }
        });
      }
    },
    modulesChoose (e) {
      this.projectType = e[0];
      this.projectSubType = e[1];
    },
    getshowstep (e) {
      // console.log(e);
      if (e === 'back') {
        this.showstep = '1';
        this.submitStatus = 'back';
        return;
      }
      if (e === 'next') {
        this.showstep = '3';
        return;
      }
      if (e === 'file') {
        this.showstep = '2';
        this.showfile = 'file';
        return;
      }
    },
    getid (e) {
      if (this.id) {
        this.selectInfoByProjectId(this.id);
      } else {
        this.selectInfoByProjectId(e);
      }

    },
    filelist (e) {
      this.getfilelist = e;
    },
    // 上一步
    previousStep () {
      let str = '';
      if (this.id && this.oldId) {
        str = '?id=' + this.id + '&oldId=' + this.oldId;
      } else if (this.id) {
        str = '?id=' + this.id;
      } else {
        str = '?oldId=' + this.oldId;
      }
      this.$router.replace('/publish-project/publisher-info' + str);
    },
    onLandTotalForm (event) {
      this.landTotalForm = event;
    },
    // 下一步
    next: debounce(function () {

      Promise.all([this.$refs['basicForm'].test()]).then(res => {
        const obj = {
          ...res[0],
          ...res[1],
          ...res[2]
        };
        if (obj.payType !== '2') {
          delete obj.installments;
        } else {
          obj.installments.forEach(item => delete item.key);
        }
        obj.assetsInfo = JSON.stringify(obj.massifs);
        delete obj.massifs;
        // console.log(obj, 1);
        this.batchinfo = obj;
        if (this.assetsCode) {
          obj['assetsCode'] = this.assetsCode;
        }
        if (obj.fileData === '') {
          errorMessage('请上传批量协议文件');
          return;
        } else {
          this.fileData = obj.fileData;
          this.submitStatus = 'ongoing';
          this.saveProjectInfo(obj);
        }

      }, (error) => {
        console.log(error);
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 保存
    uploadfile (file) {
      this.fileinfo = file;
    },
    getfilePath (file) {
      let params = new FormData();
      params.append('filePath', file);
      this.fileinfo = params;
      this.fileinfo.append('id', this.id);
    },
    saveProjectInfo () {
      if (this.fileData === '文件地址') {
        this.fileinfo = new FormData();
      }
      this.fileinfo.append('projectType', this.batchinfo.projectType);
      this.fileinfo.append('projectSubType', this.batchinfo.projectSubType);
      this.fileinfo.append('tradeType', this.batchinfo.tradeType);
      this.fileinfo.append('city', this.batchinfo.city);
      this.fileinfo.append('county', this.batchinfo.county);
      this.fileinfo.append('township', this.batchinfo.township);
      this.fileinfo.append('village', this.batchinfo.village);
      this.fileinfo.append('address', this.batchinfo.address);
      this.fileinfo.append('managementSubjectCode', this.batchinfo.managementSubjectCode);
      this.fileinfo.append('transferType', this.batchinfo.transferType);
      this.fileinfo.append('startTime', this.batchinfo.startTime);
      this.fileinfo.append('endTime', this.batchinfo.endTime);
      this.fileinfo.append('purpose', this.batchinfo.purpose);
      this.fileinfo.append('bidName', this.batchinfo.projectAddress + this.batchinfo.bidName);
      this.fileinfo.append('projectAddress', this.batchinfo.projectAddress);
      if (this.id) {
        if (this.fileData === '文件地址') {
          this.fileinfo.append('filePath', this.projectInfo.excelPath);
          this.fileinfo.append('id', this.id);
          PublishProjectService.updateBatchProject(this.fileinfo).then(res => {
            if (res && res.code === '0') {
              this.submitStatus = 'ongoing';
              this.$store.commit('SET_TRADE_TYPE', '3');
              this.$store.commit('SET_PROCESS_LIST', ['编辑项目信息', '上传附件信息', '承诺信息', '提交申请']);
              this.showstep = '2';
            } else if (res && res.reason) {
              errorMessage(res && res.reason);
              this.submitStatus = 'failed';
            }
          }, error => {
            console.log(error);
            this.submitStatus = 'failed';
            this.$message.error('上传的模板协议错误！');
          });
        } else {
          this.fileinfo.append('id', this.id);
          PublishProjectService.updateBatchProject(this.fileinfo).then(res => {
            if (res && res.code === '0') {
              this.dataid = 0;
              this.submitStatus = 'ongoing';
              this.$store.commit('SET_TRADE_TYPE', '3');
              this.$store.commit('SET_PROCESS_LIST', ['编辑项目信息', '上传附件信息', '承诺信息', '提交申请']);
              this.showstep = '2';
            } else if (res && res.reason) {
              errorMessage(res && res.reason);
              this.submitStatus = 'failed';
            }
          }, error => {
            console.log(error);
            this.submitStatus = 'failed';
            this.$message.error('上传的模板协议错误！');
          });
        }

      } else {
        PublishProjectService.savebatch(this.fileinfo).then(res => {
          if (res && res.code === '0') {
            this.dataid = res.data;
            this.submitStatus = 'ongoing';
            this.$store.commit('SET_TRADE_TYPE', '3');
            this.$store.commit('SET_PROCESS_LIST', ['编辑项目信息', '上传附件信息', '承诺信息', '提交申请']);
            this.showstep = '2';
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          }
        }, error => {
          console.log(error);
          this.submitStatus = 'failed';
          this.$message.error('上传的模板协议错误！');
        });
      }

    },
    // 更新
    updateProjectInfo (obj) {
      PublishProjectService.updateProjectInfo({
        ...obj,
        projectId: this.id
      }).then(res => {
        // console.log(obj);
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          if (this.$refs['basicForm'].ruleForm.tradeType === '1') {
            if (this.oldId) {
              this.$router.push('/publish-project/transferee-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType + '&projectSubType=' + obj.projectSubType);
            } else {
              this.$router.push('/publish-project/transferee-info?id=' + this.id + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType + '&projectSubType=' + obj.projectSubType);
            }
          } else {
            if (this.oldId) {
              this.$router.push('/publish-project/attachment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType + '&projectSubType=' + obj.projectSubType);
            } else {
              this.$router.push('/publish-project/attachment-info?id=' + this.id + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType + '&projectSubType=' + obj.projectSubType);
            }
          }
        } else if (res && res.reason) {
          this.submitStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.submitStatus = 'failed';
          errorMessage('保存项目信息失败');
        }
      }, (error) => {
        this.submitStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存项目信息失败');
        }
      });
    }
  }
};
